import * as React from 'react';
import { SVGProps } from 'react';

const DeleteIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={23}
    fill="none"
    {...props}
  >
    <path
      fill="#EB5757"
      d="M11.768 17.34h.964c.128 0 .25-.05.341-.138a.468.468 0 0 0 .141-.335V8.362a.468.468 0 0 0-.14-.334.487.487 0 0 0-.342-.138h-.964c-.128 0-.25.05-.341.138a.468.468 0 0 0-.141.334v8.505c0 .126.05.246.14.335.091.088.214.138.342.138Zm6.59-13.23h-3.312L13.68 1.877a1.912 1.912 0 0 0-.704-.672 1.959 1.959 0 0 0-.95-.245H7.974c-.333 0-.66.084-.95.245-.29.161-.533.393-.704.672L4.954 4.11H1.643a.65.65 0 0 0-.455.184A.624.624 0 0 0 1 4.74v.63c0 .167.068.327.188.445A.65.65 0 0 0 1.643 6h.643v13.23c0 .501.203.982.565 1.336.361.355.852.554 1.363.554h11.572c.511 0 1.002-.2 1.363-.554.362-.354.565-.835.565-1.336V6h.643a.65.65 0 0 0 .455-.185A.624.624 0 0 0 19 5.37v-.63a.624.624 0 0 0-.188-.446.65.65 0 0 0-.455-.184ZM7.903 2.965a.239.239 0 0 1 .208-.115h3.776a.245.245 0 0 1 .207.115l.702 1.145H7.203l.701-1.145Zm7.882 16.265H4.214V6h11.572v13.23Zm-8.518-1.89h.964c.128 0 .25-.05.341-.138a.468.468 0 0 0 .141-.335V8.362a.468.468 0 0 0-.14-.334.487.487 0 0 0-.342-.138h-.964c-.128 0-.25.05-.341.138a.468.468 0 0 0-.141.334v8.505c0 .126.05.246.14.335.091.088.214.138.342.138Z"
    />
  </svg>
);

export default DeleteIcon;
